module.exports = __webpack_public_path__ + "5b1bea15b6618a0391c7548c2faa3470.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/JP.svg
// module id = XOxr
// module chunks = 0